// extracted by mini-css-extract-plugin
export var avatarContainer = "_8u-0";
export var avatarTypingWave = "_8u-i";
export var gray = "_8u-f";
export var green = "_8u-c";
export var icon = "_8u-9";
export var image = "_8u-1";
export var lg = "_8u-6";
export var md = "_8u-5";
export var presenceDot = "_8u-b";
export var red = "_8u-d";
export var sm = "_8u-4";
export var status = "_8u-a";
export var typingDot = "_8u-h";
export var typingPill = "_8u-g";
export var xl = "_8u-7";
export var xs = "_8u-3";
export var xxl = "_8u-8";
export var xxs = "_8u-2";
export var yellow = "_8u-e";